__turbopack_context__.v({
  "buttons": "jet-card-module-scss-module__dtUBGq__buttons",
  "callCta": "jet-card-module-scss-module__dtUBGq__callCta",
  "containerJetCard": "jet-card-module-scss-module__dtUBGq__containerJetCard",
  "contentArea": "jet-card-module-scss-module__dtUBGq__contentArea",
  "descriptor": "jet-card-module-scss-module__dtUBGq__descriptor",
  "imgdesktopIcon": "jet-card-module-scss-module__dtUBGq__imgdesktopIcon",
  "imgmobileIcon": "jet-card-module-scss-module__dtUBGq__imgmobileIcon",
  "imgtabletIcon": "jet-card-module-scss-module__dtUBGq__imgtabletIcon",
  "jetcard": "jet-card-module-scss-module__dtUBGq__jetcard",
  "textandbuttons": "jet-card-module-scss-module__dtUBGq__textandbuttons",
  "title": "jet-card-module-scss-module__dtUBGq__title",
});
